export default {
  props: {
    showValidation: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    fieldValue: {
      handler () {
        this.validate();
      },
      deep: true
    }
  },
  created () {
    this.validate();
  },
  methods: {
    validate () {
      this.$emit( "validate", {
        alias: this.$options.name,
        valid: this.isValid
      } );
    }
  }
};
